import { cn } from '@/utils';
import React from 'react';

export default function Alert({
  children,
  title,
  action,
  className,
}: {
  children: React.ReactNode;
  title?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'mb-6 space-y-4 rounded-xl bg-brand-dark-75/20 p-4 text-center dark:bg-brand-dark-50',
        className
      )}
    >
      {title && (
        <h3 className="font-semibold text-brand-dark-100 dark:text-brand-light-100">
          {title}
        </h3>
      )}
      <div className="text-sm dark:text-brand-light-25">{children}</div>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
